import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, customParams: CustomParams, ...rest }) => {

  CustomParams = CustomParams || {};

  const { keycloak } = useKeycloak();
  const user = JSON.parse(localStorage.getItem('user'));
  const isAuthenticated = keycloak?.authenticated;

  return (<Route
    {...rest}
    render={props => {
      if (isAuthenticated) {
        if (CustomParams.authRequired) {
          if (user?.role === 'ADMIN') {
            return <Component {...props} />;
          } else {
            return <Redirect
              to={{
                pathname: '/dashboard',
                state: { from: props.location }
              }}
            />;
          }
        } else {
          return <Component {...props} />;
        }
      }
    }}
  />);
};

export default PrivateRoute;
